module.exports = __webpack_public_path__ + "static/media/1.5190c3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/1.png
// module id = 1339
// module chunks = 0